import restaurantsActions from '../actionTypes/restaurantsActions';

const initialState = {
  isLoading: true,
  data: { restaurants: [] },
  per: 10,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case restaurantsActions.getRestaurantsList:
      return {
        ...state,
        ...action.payload,
        isLoading: true,
      };
    case restaurantsActions.getRestaurantsListSuccess:
    case restaurantsActions.getRestaurantsListFailed:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    case restaurantsActions.deleteRestaurant:
    case restaurantsActions.deleteRestaurantSuccess:
    case restaurantsActions.deleteRestaurantFailed:
    default:
      return state;
  }
};
